import { createSelectors as a } from "@waitroom/state";
import { create as i } from "zustand";
const n = i()(
  () => ({
    navigation: void 0
  })
), e = a(n), c = (t) => {
  e.setState(
    (o) => ({
      ...o,
      ...t
    })
  );
}, g = (t) => {
  e.setState((o) => ({
    ...o,
    navigation: typeof t == "string" ? { path: t } : t
  }));
};
export {
  g as navigateTo,
  c as updateNavigation,
  e as useNavigation
};
